var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Edit Organization")]),_c('v-container',[_c('OrganizationForm',{attrs:{"type":"UPDATE","organization":_vm.organization}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }